/**
 * @generated SignedSource<<66dd3a6a90b8f2a9b57a4f9f7837a66f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettings_mainSettingsFragment$data = {
  readonly alertOnSlow: boolean;
  readonly cutOffOK: boolean | null;
  readonly cutoff: number | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "selfServiceSettings_mainSettingsFragment";
};
export type selfServiceSettings_mainSettingsFragment$key = {
  readonly " $data"?: selfServiceSettings_mainSettingsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "selfServiceSettings_mainSettingsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cutoff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cutOffOK",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertOnSlow",
      "storageKey": null
    }
  ],
  "type": "UserJourney",
  "abstractKey": null
};

(node as any).hash = "4499887cebfde56f7ccf1c479b4a4098";

export default node;
